import React from "react";
import LibraryChatCard from "@/components/dashboard/LibraryChatCard";

const DashboardChat: React.FC = () => {
  return (
    <div className="p-6 md:p-8">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-foreground">AI Assistant</h1>
        <p className="text-muted-foreground mt-2">
          Ask questions and get answers from the Repository and additional AI sources including Magisterium.
        </p>
      </div>
      
      <LibraryChatCard 
        title="Chat With the Repository"
        description="Ask questions and get answers sourced from the Repository and Magisterium."
        className="max-w-4xl"
      />
    </div>
  );
};

export default DashboardChat;
